// src/stone/illustrations/CoinsStackShineIllustration.tsx
import { jsx, jsxs } from "react/jsx-runtime";
var CoinsStackShineIllustration = (props) => /* @__PURE__ */ jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 35 28",
    ...props,
    children: [
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#42EC9A",
          d: "M25.03 13.928v4.93h1.348v9.084H1.43V5.482h12.472v4.459h12.476v3.987z"
        }
      ),
      /* @__PURE__ */ jsx("path", { fill: "#1D232A", d: "M13.903 18.623h-1.348v9.272h1.348z" }),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#42EC9A",
          d: "M7.087 18.857H.078v8.685h7.009zM7.087 9.94H.078v3.988h7.009z"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#fff",
          d: "M4.816 5.482H2.885v22.185h1.931zM6.183 5.482h-.708v22.185h.708z"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#1D232A",
          d: "M13.903 9.469H1.428v.471h12.475zM25.032 13.928H1.428v.471h23.604zM25.032 18.389H1.428v.47h23.604zM26.377 22.846H.078v.471h26.299z"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#1D232A",
          d: "m13.438 9.941-.018 3.68h.483V28h2.677L13.94 9.94z"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#FFC44F",
          d: "M22.963 7.282c2.936.798 5.505 3.073 6.19 5.864.845-2.8 2.815-5.067 5.723-5.864-2.828-.8-5.016-3.192-5.723-6.378-.558 3.212-2.708 5.613-6.19 6.378M16.58 4.108c1.863.506 3.483 1.94 3.917 3.71.536-1.775 1.794-3.213 3.638-3.72-1.794-.507-3.18-2.024-3.629-4.043C19.94 2.07 18.45 3.59 16.58 4.108"
        }
      )
    ]
  }
);
var CoinsStackShineIllustration_default = CoinsStackShineIllustration;

export {
  CoinsStackShineIllustration,
  CoinsStackShineIllustration_default
};
